import { apiClient } from "./api";
import type { DataModel } from "@shared/types";

export async function generateApp(prompt: string, agentId?: string): Promise<{ data: Record<string, unknown>; source: string }> {
  // 真实 LLM 生成可能耗时数十秒到数分钟，不能用全局 30s 超时
  const response = await apiClient.post("/ai/generate-app", { prompt, agent_id: agentId }, { timeout: 240_000 });
  return response.data;
}

export async function aiChat(
  message: string,
  agentId?: string,
  sessionId?: string,
): Promise<{ source: string; response: Record<string, unknown> }> {
  const response = await apiClient.post("/ai/chat", { message, agent_id: agentId, session_id: sessionId }, { timeout: 90_000 });
  return response.data;
}

export async function applyDataModels(appId: string, dataModels: DataModel[]): Promise<{ applied: string[]; errors: string[] }> {
  const response = await apiClient.post(`/apps/${appId}/apply-data-models`, { dataModels });
  return response.data;
}
